
import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import {
  IPagination,
  IPaginationResult,
} from "app/common/interfaces";
import {
  andAllWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ICreateNotificationTemplate, IUpdateNotificationTemplate } from "./interfaces/templace-interface";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { NotificationTemplateAttributes } from "@albatrosdeveloper/ave-models-package";

const apiUrl = env.API_AVE_NOTIFICATION;
const moduleName = "notification_template";

@Injectable({
  providedIn: "root",
})
export class TemplateService extends AbstractService<
  NotificationTemplateAttributes,
  ICreateNotificationTemplate,
  IUpdateNotificationTemplate
> {

  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * List
   * @param options IPagination
   * @param dataToFilter optional filters (company, salesOffice, etc.)
   * @returns Data list
   */
  getAllPaginate(
    options: IPagination<any>,
    dataToFilter?: IFilters
  ): Observable<IPaginationResult<NotificationTemplateAttributes>> {
    const query = buildQuery<any>(
      where("_deleted", Ops.eq(false)),

      // search for name and subject
      andAllWhere("name", Ops.like(options.search ?? "", "i")),
      orWhere("subject", Ops.like(options.search ?? "", "i")),

      // filters
      
      dataToFilter?.companyId ? andAllWhere("company.id", Ops.eq(dataToFilter.companyId)) : noop(),
      dataToFilter?.salesOfficeId?.length ? andAllWhere("salesOffice.id", Ops.in(...dataToFilter.salesOfficeId)) : noop(),
      dataToFilter?.distributionChainId?.length ? andAllWhere("distributionChain.id", Ops.in(...dataToFilter.distributionChainId)) : noop(),
      dataToFilter?.status?.length ? andAllWhere("statusId", Ops.in(...dataToFilter.status)) : noop(),
      
      // order and pagine
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
      );
  
    
     const API_URL: string = `${apiUrl}api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<NotificationTemplateAttributes>>(API_URL);
  }


}
